import { addDays, isAfter, isBefore, min, parseISO, isSameDay } from 'date-fns';
import { END_DATE, START_DATE } from './../../useDatePicker/useDatePicker/useDatePicker';
import { BlackoutDates } from 'src/components/containers/VerticalBookingContainer/blackoutDates';

export const useBlackoutDates = ({ startDate, maxRange }: { startDate: any; maxRange: any }) => {
  const getMinDate = (array: string[]) => {
    let minDate = parseISO(array[0]);
    for (let index = 0; index < array.length; index++) {
      const date = parseISO(array[index]);
      if (isBefore(date, minDate)) {
        minDate = date;
      }
    }
    return minDate;
  };

  const getMaxDate = (array: string[]) => {
    let maxDate = parseISO(array[0]);
    for (let index = 0; index < array.length; index++) {
      const date = parseISO(array[index]);
      if (isAfter(date, maxDate)) {
        maxDate = date;
      }
    }
    return maxDate;
  };

  function getMaxBookingDate(maxDate: Date | undefined, startDate_: any, maxRange_: any) {
    const maxDateByConfig = maxDate;
    if (startDate_ && maxRange_) {
      const maxDateByMaxRange = addDays(startDate_, maxRange_ - 1);
      return maxDateByConfig ? min([maxDateByConfig, maxDateByMaxRange]) : maxDateByMaxRange;
    }
    return maxDateByConfig;
  }

  const getMinBlackoutDate = (
    minDate: Date,
    blackoutDatesIntegration: boolean | undefined,
    fetchBlackoutDates: BlackoutDates | null,
    focusedInput: string | null
  ) => {
    if (blackoutDatesIntegration !== true) {
      return minDate;
    } else {
      if (focusedInput === START_DATE) {
        if (
          blackoutDatesIntegration &&
          fetchBlackoutDates &&
          fetchBlackoutDates?.departure &&
          fetchBlackoutDates?.departure?.minDate
        ) {
          if (fetchBlackoutDates?.departure?.includedDates) {
            const minDate_ = getMinDate(fetchBlackoutDates?.departure?.includedDates);
            const fetchMinDate = parseISO(fetchBlackoutDates?.departure?.minDate);
            if (
              (isAfter(minDate_, new Date()) || isSameDay(minDate_, new Date())) &&
              isBefore(minDate_, fetchMinDate)
            ) {
              return minDate_;
            } else {
              if (isAfter(fetchMinDate, new Date()) || isSameDay(fetchMinDate, new Date())) {
                return fetchMinDate;
              }
            }
            return minDate;
          } else {
            const fetchMinDate = parseISO(fetchBlackoutDates?.departure?.minDate);
            if (isAfter(fetchMinDate, new Date()) || isSameDay(fetchMinDate, new Date())) {
              return fetchMinDate;
            }
            return minDate;
          }
        } else {
          if (fetchBlackoutDates?.departure?.includedDates) {
            const minDate_ = getMinDate(fetchBlackoutDates?.departure?.includedDates);
            if (isAfter(minDate_, new Date()) || isSameDay(minDate_, new Date())) {
              return minDate_;
            }
          }
          return minDate;
        }
      } else if (focusedInput === END_DATE) {
        if (
          blackoutDatesIntegration &&
          fetchBlackoutDates &&
          fetchBlackoutDates?.return &&
          fetchBlackoutDates?.return?.minDate
        ) {
          if (fetchBlackoutDates?.return?.includedDates) {
            const minDate_ = getMinDate(fetchBlackoutDates?.return?.includedDates);
            const fetchMinDate = parseISO(fetchBlackoutDates?.return?.minDate);
            if (
              (isAfter(minDate_, new Date()) || isSameDay(minDate_, new Date())) &&
              isBefore(minDate_, fetchMinDate)
            ) {
              return minDate_;
            } else {
              if (isAfter(fetchMinDate, new Date()) || isSameDay(fetchMinDate, new Date())) {
                return fetchMinDate;
              }
            }
            return minDate;
          } else {
            const fetchMinDate = parseISO(fetchBlackoutDates?.return?.minDate);
            if (isAfter(fetchMinDate, new Date()) || isSameDay(fetchMinDate, new Date())) {
              return fetchMinDate;
            }
            return minDate;
          }
        } else {
          if (fetchBlackoutDates?.return?.includedDates) {
            const minDate_ = getMinDate(fetchBlackoutDates?.return?.includedDates);
            if (isAfter(minDate_, new Date()) || isSameDay(minDate_, new Date())) {
              return minDate_;
            }
          }
          return minDate;
        }
      }
    }
  };

  const getMaxBlackoutDate_ = (
    maxDate: Date | undefined,
    blackoutDatesIntegration: boolean | undefined,
    fetchBlackoutDates: BlackoutDates | null,
    focusedInput: string | null
  ) => {
    if (blackoutDatesIntegration !== true) {
      return getMaxBookingDate(maxDate, startDate, maxRange);
    } else {
      if (focusedInput === START_DATE) {
        if (
          blackoutDatesIntegration &&
          fetchBlackoutDates &&
          fetchBlackoutDates?.departure &&
          fetchBlackoutDates?.departure?.maxDate
        ) {
          if (fetchBlackoutDates?.departure?.includedDates) {
            const maxDate_ = getMaxDate(fetchBlackoutDates?.departure?.includedDates);
            const fetchMaxDate = parseISO(fetchBlackoutDates?.departure?.maxDate);
            if (
              (isAfter(maxDate_, new Date()) || isSameDay(maxDate_, new Date())) &&
              isAfter(maxDate_, fetchMaxDate)
            ) {
              return getMaxBookingDate(maxDate_, startDate, maxRange);
            } else {
              if (isAfter(fetchMaxDate, new Date()) || isSameDay(fetchMaxDate, new Date())) {
                return getMaxBookingDate(fetchMaxDate, startDate, maxRange);
              }
            }
            return getMaxBookingDate(maxDate, startDate, maxRange);
          } else {
            const fetchMaxDate = parseISO(fetchBlackoutDates?.departure?.maxDate);
            if (
              isAfter(fetchMaxDate, new Date()) ||
              (isSameDay(fetchMaxDate, new Date()) && maxDate && isAfter(fetchMaxDate, maxDate))
            ) {
              return getMaxBookingDate(fetchMaxDate, startDate, maxRange);
            }
            return getMaxBookingDate(maxDate, startDate, maxRange);
          }
        } else {
          if (fetchBlackoutDates?.departure?.includedDates) {
            const maxDate_ = getMaxDate(fetchBlackoutDates?.departure?.includedDates);
            if (isAfter(maxDate_, new Date()) && maxDate && isAfter(maxDate_, maxDate)) {
              return getMaxBookingDate(maxDate_, startDate, maxRange);
            }
          }
          return getMaxBookingDate(maxDate, startDate, maxRange);
        }
      } else if (focusedInput === END_DATE) {
        if (
          blackoutDatesIntegration &&
          fetchBlackoutDates &&
          fetchBlackoutDates?.return &&
          fetchBlackoutDates?.return?.maxDate
        ) {
          if (!fetchBlackoutDates?.return?.includedDates) {
            return getMaxBookingDate(
              parseISO(fetchBlackoutDates?.return?.maxDate),
              startDate,
              maxRange
            );
          } else {
            const maxDate_ = getMaxDate(fetchBlackoutDates?.return?.includedDates);
            return getMaxBookingDate(maxDate_, startDate, maxRange);
          }
        }
        return getMaxBookingDate(maxDate, startDate, maxRange);
      }
    }
  };

  return { getMinBlackoutDate, getMaxBlackoutDate_ };
};
